var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigninShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 670,
    height: 900,
    viewBox: "0 0 670 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M617.98 898.558C601.062 1151.55 -28 898.558 -28 898.558V0H257.991C379.988 0 666.659 70.1292 669.979 261.326C672.88 428.409 376.566 392.205 363.988 558.835C351.497 724.315 629.053 732.976 617.98 898.558Z",
    fill: "#D59344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninShape1);
export default __webpack_public_path__ + "static/media/Signin-shape1.2daf6847af710f1ed0673461a9791c28.svg";
export { ForwardRef as ReactComponent };